const comments = [
  {
    id: 1,
    name: '吃瓜一线猹',
    avatar: 'R',
    time: '2小时前',
    content: '这个平台太牛了！每次有大瓜都是这里最先看到，比微博快多了。编辑部加鸡腿！',
    likes: '2.3万',
    source: '来自 #明星塌房 话题',
  },
  {
    id: 2,
    name: '匿名网友9527',
    avatar: '匿',
    time: '5小时前',
    content: '作为业内人，这里的爆料准确度真的很高。有些细节和我知道的内部情况完全对得上，respect！',
    likes: '1.8万',
    source: '来自 #网红互撕 话题',
  },
  {
    id: 3,
    name: '今天吃瓜了吗',
    avatar: '瓜',
    time: '8小时前',
    content: '每天上班第一件事就是打开51每日大赛看看今天有什么新瓜，比刷朋友圈有意思多了哈哈哈。',
    likes: '1.5万',
    source: '来自 #吃瓜日常 话题',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2">来看看其他瓜友都在说什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center font-heading font-bold text-accent-700 text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.content}
              </p>

              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded">
                  {item.source}
                </span>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}